import * as types from "../types";

const INITIAL_STATE = {
  idcheck: {},
  pages: [],
  developments: [],
  developmentProperties: [],
  splashData: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_PAGES: {
      return { ...state, pages: action.pages };
    }
    case types.SET_ID_CHECK: {
      return { ...state, idcheck: action.idcheck };
    }
    case types.SET_DEVELOPMENTS: {
      return { ...state, developments: action.developments };
    }
    case types.SET_DEVELOPMENTS_PROPERTIES: {
      return { ...state, developmentProperties: action.developmentProperties };
    }
    case types.SET_SPLASHDATA: {
      return { ...state, splashData: action.splashData };
    }
    default: {
      return state;
    }
  }
};
